export default __webpack_public_path__ + "7288d80b8fda651f2c5975878ee3ec72.png";